"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarLine = exports.AvatarCircle = exports.Avatar = void 0;
const react_1 = __importStar(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const solid_1 = require("@heroicons/react/solid");
const themes_1 = require("./themes");
function getShortName(name, size) {
    var _a, _b, _c, _d;
    return (size === 'small')
        ? name.substring(0, 1).toUpperCase()
        : `${((_b = (_a = name.split(' ')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || ''}${((_d = (_c = name.split(' ')) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d[0]) || ''}`
            .toUpperCase();
}
const starClasses = {
    small: 'h-2.5 w-2.5',
    default: 'h-3 w-3',
    large: 'h-4 w-4',
    extraLarge: 'h-4 w-4',
};
function Avatar(props) {
    const [isError, setError] = (0, react_1.useState)(false);
    const theme = themes_1.themes.avatar;
    const size = props.size || 'default';
    const classNamesCombined = (0, elements_ui_utils_1.classNames)(props.className, theme.shared, theme.sizes[size]);
    const fontSizeClasses = {
        small: 'text-xs',
        default: 'text-sm',
        large: 'text-lg',
        extraLarge: 'text-xl',
    };
    if (props.src && !isError) {
        return (react_1.default.createElement("span", { className: "relative flex flex-shrink-0" },
            props.favorite && (react_1.default.createElement("span", { className: (0, elements_ui_utils_1.classNames)(starClasses[size], 'absolute -bottom-0.5 -right-0.5 border-2 border-warn-500 rounded-full bg-warn-500') },
                react_1.default.createElement(solid_1.StarIcon, { className: "text-absolute-700" }))),
            react_1.default.createElement("img", { onError: () => setError(true), onLoad: () => setError(false), className: classNamesCombined, key: props.alt, src: props.src, alt: props.alt })));
    }
    return (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)(classNamesCombined, 'flex justify-center items-center', 'text-white font-medium', fontSizeClasses[size]), style: { backgroundColor: (0, elements_ui_utils_1.getHslFromString)(props.alt) } }, getShortName(props.alt, props.size)));
}
exports.Avatar = Avatar;
function AvatarCircle({ size = 'default', className = '', src = '', alt = '', favorite = false, }) {
    var _a;
    const [isError, setError] = (0, react_1.useState)(false);
    const theme = themes_1.themes.avatarCircle;
    const fontSizeClasses = {
        small: 'text-xs',
        default: 'text-sm',
        large: 'text-lg',
        extraLarge: 'text-xl',
    };
    const classNamesCombined = (0, elements_ui_utils_1.classNames)(className, theme.shared, theme.sizes[size]);
    if (src && !isError) {
        return (react_1.default.createElement("span", { className: "relative flex flex-shrink-0" },
            favorite && (react_1.default.createElement("span", { className: (0, elements_ui_utils_1.classNames)(starClasses[size], 'absolute -bottom-0.5 -right-0.5 border-2 border-warn-500 rounded-full bg-warn-500') },
                react_1.default.createElement(solid_1.StarIcon, { className: "text-absolute-700" }))),
            react_1.default.createElement("img", { onError: () => setError(true), onLoad: () => setError(false), className: classNamesCombined, key: alt, src: src, alt: alt })));
    }
    return (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)(classNamesCombined, 'relative flex flex-shrink-0 justify-center items-center', 'text-white font-medium', fontSizeClasses[size]), style: { backgroundColor: (0, elements_ui_utils_1.getHslFromString)(alt) } },
        favorite
            && (react_1.default.createElement("span", { className: (0, elements_ui_utils_1.classNames)(starClasses[size], 'absolute -bottom-0.5 -right-0.5 border-2 border-warn-500 rounded-full bg-warn-500') },
                react_1.default.createElement(solid_1.StarIcon, { className: "text-absolute-700" }))), (_a = getShortName(alt, size)) !== null && _a !== void 0 ? _a : null));
}
exports.AvatarCircle = AvatarCircle;
function AvatarLine({ size = 'default', position = 'top', ringColor = '', className = '', data = [], }) {
    const theme = themes_1.themes.avatarLine;
    const positionClasses = {
        top: 'mb-1',
        bottom: 'mt-1',
        inline: '',
    };
    return (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)(theme.container, positionClasses[position], className) },
        react_1.default.createElement("div", { className: theme.inner }, data.map((item) => {
            var _a;
            return (react_1.default.createElement(AvatarCircle, { size: size, className: (0, elements_ui_utils_1.classNames)(ringColor || 'ring-white', 'ring-2'), key: item.alt, src: item.src, alt: item.alt, favorite: (_a = item.favorite) !== null && _a !== void 0 ? _a : false }));
        }))));
}
exports.AvatarLine = AvatarLine;
//# sourceMappingURL=avatar.js.map